export default function PHP_str_repeat() {
  return (
    <div>
      <h1>PHP_str_repeat</h1>
    </div>
  );
}
